import React, { useState } from 'react';
import { Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import api from './api';

function SifreSifirla() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [yeniSifre, setYeniSifre] = useState('');
  const [yeniSifreTekrar, setYeniSifreTekrar] = useState('');
  const [mesaj, setMesaj] = useState('');
  const [hata, setHata] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHata('');
    if (yeniSifre.length < 8) {
      setHata('Şifre en az 8 karakter olmalıdır.');
      return;
    }
    if (yeniSifre !== yeniSifreTekrar) {
      setHata('Şifreler eşleşmiyor.');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/sifre-sifirlama', { token, yeni_sifre: yeniSifre });
      setMesaj(res.data.mesaj);
    } catch (err) {
      setHata(err.response?.data?.mesaj || 'Şifre sıfırlanamadı. Bağlantının süresi dolmuş olabilir.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'relative', height: '100vh' }}>
      <div className="aurora-background" />
      <div className="d-flex align-items-center justify-content-center h-100" style={{ position: 'relative', zIndex: 1 }}>
        <Card className="glass-card text-white" style={{ width: '24rem' }}>
          <Card.Body>
            <h2 className="text-center mb-4">Yeni Şifre Belirle</h2>
            {!token ? (
              <>
                <Alert variant="danger">Geçersiz bağlantı. Lütfen e-postanızdaki bağlantıyı kullanın.</Alert>
                <div className="text-center">
                  <Link to="/sifremi-unuttum" className="btn btn-outline-light btn-sm">Yeni bağlantı iste</Link>
                </div>
              </>
            ) : mesaj ? (
              <>
                <Alert variant="success">{mesaj}</Alert>
                <div className="text-center">
                  <Link to="/giris" className="btn btn-primary btn-sm">Giriş Yap</Link>
                </div>
              </>
            ) : (
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Yeni Şifre</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="En az 8 karakter"
                    value={yeniSifre}
                    onChange={(e) => setYeniSifre(e.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label>Yeni Şifre (Tekrar)</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Şifrenizi tekrar girin"
                    value={yeniSifreTekrar}
                    onChange={(e) => setYeniSifreTekrar(e.target.value)}
                    required
                  />
                </Form.Group>
                <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                  {loading ? <Spinner size="sm" animation="border" /> : 'Şifreyi Güncelle'}
                </Button>
                {hata && <Alert variant="danger" className="mt-3">{hata}</Alert>}
              </Form>
            )}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}

export default SifreSifirla;
